<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="stroke-current"
    :height="height"
    :width="width"
    :viewBox="`0 0 ${height} ${width}`"
    v-bind="svgProps"
    :preserveAspectRatio="aspectRatio"
  >
    <component :is="iconComponent" v-bind="iconProps" :size="size" />
  </svg>
</template>

<script>
import { pascalCase } from 'change-case'

import components from '@/js/components/Shared/IconSelect/Icons'

export default {
  name: 'IconSelect',
  components,
  props: {
    icon: {
      type: String,
      required: true,
    },
    svgProps: {
      type: Object,
      default: () => ({}),
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    aspectRatio: {
      type: String,
      default: 'xMidYMid meet',
    },
  },
  data() {
    const height = this.svgProps.height || 24
    const width = this.svgProps.width || 24
    return {
      height,
      width,
      size: height > width ? height : width,
      iconComponent: this.getIconComponentName(this.icon),
      components,
    }
  },
  watch: {
    icon(newIcon, oldIcon) {
      if (newIcon !== oldIcon) {
        this.iconComponent = this.getIconComponentName(newIcon)
      }
    },
  },
  methods: {
    getIconComponentName(icon) {
      const fallbackComponentName = 'FallbackIcon'
      const componentName = `${pascalCase(icon)}Icon`

      return Object.keys(components).indexOf(componentName) < 0
        ? fallbackComponentName
        : componentName
    },
  },
}
</script>
